import React from 'react';
import { Quote } from 'acscp/store';
import { QuoteElement } from 'acscp/components/quotes/quote';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { Booking } from 'acscp/store/bookingsState';

const QuoteAcceptedComponent:
    React.FC<{quote: Quote, booking: Booking} & InjectedIntlProps> = ({quote, booking}) => {
    const jetCardHolder = booking.jetCardNo !== '';
    return (
        <QuoteElement
            quote={quote}
            collapsible={false}
            jetCardHolder={jetCardHolder}
            jetCardType={booking.jetCardType}
        />
    );
};

const QuoteAccepted = injectIntl(QuoteAcceptedComponent);
export { QuoteAccepted };
